export default __webpack_public_path__ + "static/media/call.7ed63f63.svg";